import $ from 'jquery';

$(document).ready(function () {

  // Call the function to generate the anchors

  var elements = generateAnchors(); // Array of element IDs

  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();

    if ( $('.anchors-generator').length > 0) {
      elements.forEach(function (elementId) {
        var $element = $("#" + elementId);
        var targetHref = "#" + elementId;
        var elementOffset = $element.offset().top;

        if (elementOffset >= scrollTop && elementOffset < scrollTop + windowHeight) {
          $('#magic-links').find('.dots').removeClass('active');
          $("a[href='" + targetHref + "']").addClass("active");
        }
      });
    }
  });

  $('#magic-links .dots:first').addClass('active');

  $('#magic-links').on('click', '.dots', function (e) {
    //e.preventDefault();
    var href = $(this).attr('href');
    var targetId = href.substring(1);
    var targetOffset = $('#' + targetId).offset().top - 270;
    $('html, body').animate({ scrollTop: targetOffset }, 500);

    $('.dots').removeClass('active');
    $(this).addClass('active');

  });

});

function generateAnchors() {

  var rets = [];

  // Find all HTML elements with the class "anchors-generator"
  const elements = $('.anchors-generator');

  // Create a flex container element with an ID of "magic-links"
  const flexContainer = $('<div></div>').attr('id', 'magic-links').css({
    display: 'flex',
    flexDirection: 'column'
  });

  if (elements.length > 0) {
    // Loop through each element and generate a unique ID
    elements.each(function (index) {
      const element = $(this);

      if ($(element).attr('id') == undefined) {
        // Generate a unique ID for the element
        const uniqueId = 'magic-anchor-' + index;
        // Set the generated ID to the element
        element.attr('id', uniqueId);
      }

      rets.push(element.attr('id'));

      // Create an anchor link for the element
      const anchorLink = $('<a></a>').attr('href', '#' + element.attr('id')).text('').addClass('dots');

      // Add the anchor link to the flex container
      flexContainer.append(anchorLink);
    });

    // Append the flex container to the document body
    $('body #magic-links-wrapper').append(flexContainer);

    return rets;
  }

}
